<template>
  <div class="pad1"></div>
  <div class="flex cen flex-column mt80">
    <div class="flex">
      <p>注资金额:</p>
      <input ref="moneyinput" v-model="money" readonly clickable step="0.01" class="myinvestment__input width152 height36 ml8 mr8"
        @click="handleBlur">
      <p>元</p>
    </div>
    <!-- <p class="myinvestment-tip mt50 size12">投资款未使用前随时可退</p> -->
    <button class="myinvestment-btn  size14 mt60" @click="handlePay">
      确认支付
    </button>
  </div>
  <van-number-keyboard theme="custom" close-button-text="完成" extra-key="." v-model="money" :show="show" @blur="show = false" @hide="handleHide" />

</template>
<script setup>
import { ref, defineProps } from "vue";

const money = ref('')

const props = defineProps({
  fn: {
    type: Function,
    default: () => { },
  },
});

//键盘
// const selectionStart = ref(0);//输入框光标开始位置
const moneyinput = ref();
const show = ref(false);
// const onInput = (value) => {
//   if ( selectionStart.value == 0 ) {
//     money.value = money.value? String(money.value) + String(value) : String(value)
//   } else {
//     money.value = String(money.value).slice(0,selectionStart.value) + String(value) + String(money.value).slice(selectionStart.value)
//     selectionStart.value++
//     console.dir(moneyinput.value)
//     moneyinput.value.selectionStart = selectionStart.value
//   }

// };
// const onDelete = () => {
//   if(!money.value) {
//     return
//   } else {
//     money.value = money.value.substring(0,money.value.length - 1)
//   }
// };
const handleBlur = () => {
  // selectionStart.value = e.target.selectionStart
  show.value = true
  // if (money.value && money.value !== 'undefined') {
  //     money.value = money.value.toFixed(2)
  // }
}
//键盘隐藏时
const handleHide = () => {
  if (money.value && money.value !== 'undefined') {
    money.value = Number(money.value).toFixed(2)
  }
}
//处理提交
const handlePay = () => {
  if (!money.value) {
    return
  } else {
    props.fn(Number(money.value))
  }
};
</script>
<style scoped>
.myinvestment__input {
  width: 152px;
  height: 36px;
  line-height: 36px;
  border-radius: 18px;
  background: #f0f0f0;
  text-align: right;
  padding: 0 10px;
}
.myinvestment-tip {
  text-align: center;
  color: #ff0000;
  letter-spacing: 1px;
}
.flex-column {
  flex-direction: column;
}
.myinvestment-btn {
  background-color: #3f7c93;
  text-align: center;
  line-height: 36px;
  width: 296px;
  height: 36px;
  border-radius: 21px;
  color: #ffffff;
}
.van-key {
  height: 36px;
}
</style>